export default __webpack_public_path__ + "4e43dc8e5f0ee2683289ba2b68a05f3e.svg";